class downloadButton {
    constructor(el) {
        this.DOM = { el: el };
        this.originalText = this.DOM.el.querySelector(".btn-text").textContent;
        this.loaderIcon = this.DOM.el.querySelector(".loader--icon");
        this.chevronIcon = this.DOM.el.querySelector(".btn__icon");
        this.isDisabled = false;

        this.initEvents();
    }
    initEvents = () => {
        this.DOM.el.addEventListener("click", this.handleClick);
    };

    handleClick = event => {
        if (this.isDisabled) {
            event.preventDefault();
            return;
        }

        this.isDisabled = true;
        this.DOM.el.classList.remove("btn-outline-primary");
        this.DOM.el.classList.add("btn-primary");
        this.DOM.el.classList.add("disabled");
        this.DOM.el.querySelector(".btn-text").textContent = "Downloaden...";
        this.loaderIcon.style.display = "block";
        this.chevronIcon.style.display = "none";

        setTimeout(() => {
            this.isDisabled = false;
            this.DOM.el.classList.remove("disabled");
            this.DOM.el.classList.remove("btn-primary");
            this.DOM.el.classList.add("btn-outline-primary");
            this.DOM.el.querySelector(".btn-text").textContent = this.originalText;
            this.loaderIcon.style.display = "none";
            this.chevronIcon.style.display = "block";
        }, 9000);
    };
}

const downloadButtonNodes = Array.from(document.querySelectorAll("[download-button]"));
if (downloadButtonNodes !== null) {
    downloadButtonNodes.forEach((downloadBtn) => new downloadButton(downloadBtn));
}
